module.exports = __webpack_public_path__ + "static/zycie_gruzji-7f2b8f253f7c96e9d323b150b1ac48a7.pdf";